import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";
import { AssignmentScheduleListModel } from "../models/assignment-schedule-list.model";
import { AssignmentScheduleDetailsModel } from "../models/assignment-schedule-details.model";
import { AssignmentScheduleUpdateAnswerPostModel } from "../models/assignment-schedule-update-answer-post.model";
import { AssignmentScheduleUpdateAdditionPostModel } from "../models/assignment-schedule-update-addition-post.model";
import { AssignmentScheduleFilterOptionsModel } from "../models/assignment-schedule-filter-options.model";
import { AssignmentScheduleOptionModel } from "../models/assignment-schedule-option.model";
import { AssignmentScheduleMassUpdateAnswerPostModel } from "../models/assignment-schedule-mass-update-answer-post.model";

@Injectable({
    providedIn: 'root',
})
export class AssignmentScheduleService {
    private httpClient = inject(HttpClient);

    public getAssignmentSchedules(): Observable<AssignmentScheduleListModel[]> {
        return this.httpClient.get<AssignmentScheduleListModel[]>(`${environment.api}/assignmentSchedules`);
    }

    public getUnansweredAssignmentSchedules(): Observable<AssignmentScheduleListModel[]> {
        return this.httpClient.get<AssignmentScheduleListModel[]>(`${environment.api}/assignmentSchedules/unanswered`);
    }

    public getAssignmentScheduleDetails(id: string): Observable<AssignmentScheduleDetailsModel> {
        return this.httpClient.get<AssignmentScheduleDetailsModel>(`${environment.api}/assignmentSchedules/${id}`);
    }

    public getAssignmentScheduleFilterOptionsById(id: string): Observable<AssignmentScheduleFilterOptionsModel> {
        return this.httpClient.get<AssignmentScheduleFilterOptionsModel>(`${environment.api}/assignmentSchedules/${id}/filter/options`);
    }

    public changeAssignmentScheduleAnswerById(id: string, model: AssignmentScheduleUpdateAnswerPostModel): Observable<void> {
        return this.httpClient.post<void>(`${environment.api}/assignmentSchedules/${id}/answer`, model);
    }

    public massUpdateAssignmentScheduleAnswers(id: string, model: AssignmentScheduleMassUpdateAnswerPostModel): Observable<void> {
        return this.httpClient.post<void>(`${environment.api}/assignmentSchedules/${id}/answers`, model);
    }

    public changeAssignmentScheduleAdditionById(id: string, model: AssignmentScheduleUpdateAdditionPostModel): Observable<void> {
        return this.httpClient.post<void>(`${environment.api}/assignmentSchedules/${id}/addition`, model);
    }

    public getWeekdayRange(option: AssignmentScheduleOptionModel): number[] {
        const fromIndex = option.weekdayFromIndex;
        const toIndex = option.weekdayToIndex;

        const result: number[] = [];
        let current = fromIndex;

        while (true) {
            result.push(current);

            if (current === toIndex) break;

            current++;
            if (current > 7) current = 1;
        }

        return result;
    }
}